<template>
    <CardRh :processando="processando" titulo="Unidades Cadastradas">
        <div class="unidade-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaUnidade" class="form-label">Pesquisar</label>
                        <input id="pesquisaUnidade" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pesquisar" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-3" v-if="status">
                        <label for="statusUnidade" class="form-label">Status</label>
                        <Multiselect id="statusUnidade" @change="refreshTable" :options="status_select"
                            :searchable="true" v-model="status_id" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-3" v-if="tipos">
                        <label for="tipoUnidade" class="form-label">Tipo</label>
                        <Multiselect id="tipoUnidade" @change="refreshTable" :options="tipos_select"
                            :searchable="true" v-model="tipo_id" />
                    </div>

                    <div class="col-12 col-lg-3 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                        <button v-if="hasPermissaoAdmin" type="button" class="btn btn-pmes-primary btn-sm" @click="sincronizarViaRh">
                            Sincronizar RH
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th style="max-width:90px">ID</th>
                    <th>Descricao</th>
                    <th>Qdi</th>
                    <th>Tipo</th>
                    <th>Status</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import UnidadeService from "@/service/v1/sigap/UnidadeService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Multiselect from '@vueform/multiselect';

@Options({
    name: "UnidadeIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class UnidadeIndex extends IndexModelTable {
    public status_id: any = null;
    public status: any = null;
    public tipo_id: any = null;
    public tipos: any = null;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    get hasPermissaoAdmin(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    get tipos_select() {
        if (this.tipos) {
            return this.tipos.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getTipos() {
        this.processando = true;
        this.service.getTipos()
            .then(response => {
                this.tipos = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() {
        this.search = "";
        this.status_id = null;
        this.tipo_id = null;
        this.refreshTable();
    }

    created() {
        this.service = new UnidadeService();
        this.getStatus();
        this.getTipos();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    search: this.search || d.search.value,
                    status: this.status_id,
                    tipo: this.tipo_id,
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: 'id', name: 'id', class: 'desktop' },
            { data: 'descricao', name: 'descricao' },
            { data: 'qdi', name: 'qdi', class: 'desktop' },
            { data: 'tipo.nome', name: 'tipo.nome', class: 'desktop' },
            { data: 'status', name: 'status', class: 'desktop' },
        ];
        if (this.hasPermissao) {
            this.config.columnDefs = [
                {
                    targets: 4,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        if (row.id == '1') {
                            texto = texto + '<button class="btn btn-success btn-sm" btn-retirar ' + buttom + '>Ativo</button>';
                        }
                        else {
                            texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-liberar ' + buttom + ' title="Excluir">Inativo</button>';
                        }
                        return texto;
                    },
                },
            ];
        }
    }

    public tableatualizada() {
        $("[btn-excluir]").click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.excluirModelo(id);
        });
        $("[btn-liberar]").click((btn) => {
            if (this.hasPermissao) {
                const id = $(btn.currentTarget).data('id');
                this.liberarUnidade(id);
            }
        });
        $("[btn-retirar]").click((btn) => {
            if (this.hasPermissao) {
                const id = $(btn.currentTarget).data('id');
                this.removerUnidade(id);
            }
        });
    }

    protected liberarUnidade(id) {
        this.processando = true;
        setTimeout(() => {
            this.service.ativar(id)
                .then(() => {
                    this.reloadDatatable = !this.reloadDatatable;
                    SiteUtils.toastSucesso('Acesso liberado com sucesso!!');
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }, 10);
    }

    protected removerUnidade(id) {
        this.processando = true;
        setTimeout(() => {
            this.service.inativar(id)
                .then(() => {
                    this.reloadDatatable = !this.reloadDatatable;
                    SiteUtils.toastSucesso('Acesso removido com sucesso!!');
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }, 10);
    }

    protected sincronizarViaRh() {
        this.processando = true;
        setTimeout(() => {
            this.service.sincronizarViaRh()
                .then(() => {
                    this.reloadDatatable = !this.reloadDatatable;
                    SiteUtils.toastSucesso('sucesso!!');
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }, 10);
    }
}
</script>

<style scoped>
.unidade-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
